import University from './components/University/';
import LoginHOC from '../../../../../../components/LoginHOC/';

export default (store, index = false) => ({
  component: LoginHOC(University),
});



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/University/routes/University/index.js